import { ComponentProps, ReactNode } from 'react';
import { Icon } from 'react-bulma-components';
import styles from './icon-button.module.scss';

export type IconButtonProps = Omit<
  ComponentProps<'button'>,
  'type' | 'children' | 'color'
> & {
  /** Accessible name: the button shows only an icon. */
  label: string;
  /** The icon to show. */
  children: ReactNode;
  color?: ComponentProps<typeof Icon>['color'];
};

/**
 * A button that shows only an icon. A native button, so it is focusable and
 * answers Enter and Space, named by `label` for assistive technology.
 */
export function IconButton({
  label,
  children,
  color,
  className = '',
  ...props
}: IconButtonProps) {
  return (
    <button
      {...props}
      type="button"
      aria-label={label}
      className={`${styles.iconButton} ${className}`}
    >
      <Icon color={color}>{children}</Icon>
    </button>
  );
}

export default IconButton;
